export default __webpack_public_path__ + "static/media/GBN_prj3.5699ff30.jpg";